import { Directive, HostListener, ElementRef, inject } from '@angular/core';

@Directive({
    selector: '[appUpperCase]',
    standalone: false
})
export class InputUpperCaseDirective {
    private ref = inject(ElementRef);


    lastValue: string;

    @HostListener('input', ['$event']) onInput($event) {
        let start = $event.target.selectionStart;
        let end = $event.target.selectionEnd;
        $event.target.value = $event.target.value.toUpperCase();
        $event.target.setSelectionRange(start, end);
        $event.preventDefault();
        if (!this.lastValue || (this.lastValue && $event.target.value.length > 0 && this.lastValue !== $event.target.value)) {
            this.lastValue = this.ref.nativeElement.value = $event.target.value;
            const evt = document.createEvent('HTMLEvents');
            evt.initEvent('input', false, true);
            $event.target.dispatchEvent(evt);
        }
    }
}
